import { Button } from "@shopify/polaris";
import { ISODateString } from "@smartrr/shared/entities/ISODateString";

import { GettingStartedStoreAccess } from "../../../libs/store";

export function ImportExistingSubscriptionsButton() {
  const { update } = GettingStartedStoreAccess.useActions();

  const onClick = () => {
    update(
      [
        {
          path: "onSiteSetup.migrationService",
          val: {
            completed: true,
            date: ISODateString.toString(new Date()),
          },
        },
      ],
      "migrationService"
    );
  };

  return (
    <div data-testid="migration-import-existing">
      <Button outline url="mailto:support@smartrr.com" onClick={onClick}>
        I have subscriptions to import
      </Button>
    </div>
  );
}
